import * as React from "react";
import {css} from "@emotion/react";

interface IProps {
    offsetTop: number;
}

// eslint-disable-next-line react/display-name
export const ScrollRefOffset = React.forwardRef<HTMLDivElement, IProps>((props, forwardedRef) => {
    return (
        <div
            css={css`
                position: relative;
            `}
        >
            <div
                css={css`
                    position: absolute;
                    top: ${props.offsetTop}px;
                `}
                ref={forwardedRef}
            />
        </div>
    );
});
import * as React from "react";
import {css} from "@emotion/react";

interface IProps {
    offsetTop: number;
}

// eslint-disable-next-line react/display-name
export const ScrollRefOffset = React.forwardRef<HTMLDivElement, IProps>((props, forwardedRef) => {
    return (
        <div
            css={css`
                position: relative;
            `}
        >
            <div
                css={css`
                    position: absolute;
                    top: ${props.offsetTop}px;
                `}
                ref={forwardedRef}
            />
        </div>
    );
});
